var members_gallery = ( function( $ ) {

	var gallery = {
		$element: null,
		$cake_submissions: null,
		col_heights: [ 0, 0, 0 ]
	};

	var infinite_scroll = {
		load_within_pixels: 1000,
		current_page: 1,
		more_posts: true,
		loading: false
	};

	var cake_submission_modal = {
		$element: null,
		open: false,
		loading: false,
		current_id: null,
		html: [],
	};

	var _init = function() {
		_setup_gallery();
		_setup_infinite_scroll();
		_setup_cake_submission_modal();
	};

	// Gallery
	var _setup_gallery = function() {
		gallery.$element          = $( '#members-gallery' );
		gallery.$cake_submissions = gallery.$element.find( '.cake-submissions' );
		gallery.col_heights       = gallery.$cake_submissions.data( 'col-heights' )

		_update_cake_submissions_height();

		$( window ).resize( _update_cake_submissions_height );
	};

	var _update_cake_submissions_height = function() {
		// Only calculate on larger screens
		if ( $( window ).width() < 768 ) {
			gallery.$cake_submissions.css( 'height', 'unset' );
			return;
		}

		var $cake_submission_card = gallery.$element.find( '.cake-submission-card' ).first();

		var card_width  = $cake_submission_card.width();
		var card_margin = $cake_submission_card.outerHeight( true ) - $cake_submission_card.outerHeight() + 1;

		var total_col_heights = [];

		for ( var i = 0; i < 3; i++ ) {
			// Round up to take into account inaccuracies - if you go 1 pixel over then it breaks the entire layout
			var $col_cards      = gallery.$cake_submissions.children( '.cake-submission-card:nth-child(3n+' + ( i + 1 ) + ')' );
			var ceil_col_height = Math.ceil( gallery.col_heights[ i ] * 100 ) / 100;

			total_col_heights[ i ] = ( ceil_col_height * card_width ) + ( card_margin * $col_cards.length );
		}

		gallery.$cake_submissions.css( 'height', ( Math.max( ...total_col_heights ) ) + 'px' );
	};

	// Infinite Scroll
	var _setup_infinite_scroll = function() {
		$( document ).on( 'scroll', function() {
			if ( infinite_scroll.more_posts && !infinite_scroll.loading ) {
				// Distance from bottom of screen to bottom of $cake_submissions element
				var cake_submissions_bottom_offset = ( gallery.$cake_submissions.offset().top + gallery.$cake_submissions.outerHeight() ) - ( $( window ).scrollTop() + $( window ).height() );

				if ( infinite_scroll.load_within_pixels > cake_submissions_bottom_offset ) {
					_get_posts( infinite_scroll.current_page + 1, gallery.col_heights );
				}
			}
		} );
	};

	var _get_posts = function( page, col_heights ) {
		var data = {
			action: 'crate_members_gallery_get_posts',
			nonce: ScriptData.crate_members_gallery_get_posts_nonce,
			page: page,
			col_heights: col_heights
		};

		_set_loading_posts( true );

		$.get( ScriptData.ajaxurl, data, _get_posts_response );
	};

	var _set_loading_posts = function( loading ) {
		var $spinner = gallery.$element.find( '.ajax-spinner' );

		infinite_scroll.loading = loading;

		if ( loading ) {
			$spinner.addClass( 'active' );
		} else {
			$spinner.removeClass( 'active' );
		}
	};

	var _get_posts_response = function( response ) {
		_set_loading_posts( false );

		if ( response.success ) {
			if ( response.page === infinite_scroll.current_page + 1 ) {
				infinite_scroll.current_page += 1;
				gallery.col_heights        = response.col_heights;
				infinite_scroll.more_posts = response.more_posts;

				gallery.$cake_submissions.append( response.html );

				_update_cake_submissions_height();
				_setup_cards_to_open_modal( gallery.$cake_submissions.find( '.cake-submission-card' ).slice( -response.posts_count ) );
			}
		} else if ( response.error ) {
			console.log( 'Error: ' + response.error );
		}
	};

	// Cake Submission Modal
	var _setup_cake_submission_modal = function() {
		cake_submission_modal.$element = $( '#cake-submission-modal' );

		_setup_cards_to_open_modal( gallery.$element.find( '.cake-submission-card' ) );

		cake_submission_modal.$element.on( 'click', function( e ) {
			if ( !$( e.target ).hasClass( 'exit' ) ) {
				e.stopPropagation();
			}
		} );

		cake_submission_modal.$element.find( '.exit' ).on( 'click', _close_modal );
		cake_submission_modal.$element.closest( '.crate-popup-wrap' ).on( 'click', _close_modal );
	};

	var _setup_cards_to_open_modal = function( $cards ) {
		$cards.on( 'click', function( e ) {
			e.preventDefault();
			_set_modal_content( $( this ) );
			_open_modal();
		} );
	};

	var _open_modal = function() {
		$( 'body' ).addClass( 'open-popup' );
		cake_submission_modal.$element.closest( '.crate-popup-wrap' ).fadeIn();

		cake_submission_modal.open = true;
	};

	var _close_modal = function( e ) {
		if ( e ) {
			e.preventDefault();
		}

		$( 'body' ).removeClass( 'open-popup' );
		cake_submission_modal.$element.closest( '.crate-popup-wrap' ).fadeOut();

		cake_submission_modal.open = false;
	};

	var _set_modal_content = function( $card ) {
		var cake_submission_id = $card.data( 'cake-submission-id' );

		if ( cake_submission_id && ( cake_submission_modal.current_id != cake_submission_id || typeof cake_submission_modal.current_id === 'undefined' ) ) {
			if ( typeof cake_submission_modal.html[ cake_submission_id ] !== 'undefined' ) {
				cake_submission_modal.$element.find( '.inner-popup' ).html( cake_submission_modal.html[ cake_submission_id ] );
				cake_submission_modal.current_id = cake_submission_id;
			} else {
				cake_submission_modal.$element.find( '.inner-popup' ).empty();
				_get_modal_content( cake_submission_id );
			}
		}
	};

	var _get_modal_content = function( cake_submission_id ) {
		var data = {
			action: 'crate_members_gallery_get_modal',
			nonce: ScriptData.crate_members_gallery_get_modal_nonce,
			cake_submission_id: cake_submission_id
		};

		_set_loading_modal( true );

		$.get( ScriptData.ajaxurl, data, _get_modal_content_response );
	};

	var _set_loading_modal = function( loading ) {
		var $spinner = cake_submission_modal.$element.find( '.ajax-spinner' );

		cake_submission_modal.loading = loading;

		if ( loading ) {
			$spinner.addClass( 'active' );
		} else {
			$spinner.removeClass( 'active' );
		}
	};

	var _get_modal_content_response = function( response ) {
		_set_loading_modal( false );

		if ( response.success ) {
			cake_submission_modal.$element.find( '.inner-popup' ).html( response.html );
			cake_submission_modal.current_id                          = response.cake_submission_id;
			cake_submission_modal.html[ response.cake_submission_id ] = response.html;
		} else {
			console.log( 'Error: ' + response.error );
			_close_modal();
		}
	};

	if ( $( '#members-gallery' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = members_gallery;